import axios from 'axios';
const API_BASE_URL = "https://securelab.api.sehhasolutions.com/api/billing";
//const API_BASE_URL = "https://localhost:44397/api/billing";


export const billingService = {
  // Get all billing records
getBillingHistory: async (laboratoryId) => {
    const response = await axios.get(`${API_BASE_URL}/laboratory/${laboratoryId}`);
    return response.data;
  },
getSubscriptionDetails: async (laboratoryId) => {
    const response = await axios.get(`${API_BASE_URL}/subscription/${laboratoryId}`);
    return response.data;
  },
  // Submit a new billing record
  submitBilling: async (billingData) => {
    const response = await axios.post(API_BASE_URL, billingData);
    return response.data;
  }
};